import { Box, Flex,Spinner } from '@chakra-ui/react'
import React, { Fragment, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import Details from '../../component/Details'
import DetailsHeader from '../../component/DetailsHeader'
import RightSidebar from '../../component/RightSidebar'
import TenureDetailsTable from '../../component/TenureDetailsTable'
// import Timeline from '../../component/Timeline'
import axios from 'axios'
import { Auth } from '../../component/Auth'
const TenureDetails = () => {
    const [tData, setTData] = useState({});
    const [orderData, setOrderData] = useState({})
    const [invoiceData, setInvoiceData] = useState([])
    const [updateInvoiceDetails , setUpdateInvoiceDetails] = useState(0)
    const [orderTenure, setOrderTenure] = useState({})


    const { pid, id } = useParams()

  
  // Single Order Item Tenure Data
  useEffect(() => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/tenure/${id}`,
      headers: {
        'Authorization': Auth()
      },
    };

    axios.request(config)
    .then((response) => {
      setTData(response.data)
    })
    .catch((error) => {
      console.log(error);
    });
  }, [id,updateInvoiceDetails])

  // Order Data
  useEffect(() => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/${pid}`,
      headers: {
        'Authorization': Auth()
      },
    };
    
    axios.request(config)
    .then((response) => {
      setOrderData(response.data)
    })
    .catch((error) => {
      console.log(error);
    });
    
  },[pid,updateInvoiceDetails])

  // Tenure Item Details
  let orderItemDetails = [] 
  if(Object.keys(tData).length > 0) {
    orderItemDetails = orderData?.OrderItem?.filter((x) => x?.orderItemSeqId === tData?.TenureItem[0]?.orderItemSeqId )
  }

  // Tenure Details Table --- Get All Invoice
  useEffect(() => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/invoice?tenureId=${id}`,
      headers: {
        'Authorization': Auth()
      },
    };
    
    axios.request(config)
    .then((response) => {
      setInvoiceData(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
    
  },[id,updateInvoiceDetails])


  // All Order Tenure
  useEffect(() => {

    if(Object.keys(tData).length > 0) {
      window.sessionStorage.setItem('orderItemSeqId', JSON.stringify(orderData?.OrderItem?.filter((x) => x?.orderItemSeqId === tData?.TenureItem[0]?.orderItemSeqId )))   
    }
    
    let data = JSON.stringify({
      "orderId": pid
    });
    
    let config = {
      method: 'post',
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/tenure/get-tenure-list`,
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
      data : data
    };
    
    axios.request(config)
    .then((response) => {
      let myData = response.data.filter((x) => x.orderItemSeqId === JSON.parse(window.sessionStorage.getItem('orderItemSeqId'))[0].orderItemSeqId)
      let active = myData.filter((y) => y.statusId !== "EXTENDED")
      let extended = myData.filter((y) => y.statusId === "EXTENDED")
      setOrderTenure({active: active, extend: extended});
    })
    .catch((error) => {
      console.log(error);
    });
  },[pid,tData,orderData])



  // console.log(tData, 'helloooo')

  const updateTenureDetailsTable = (data) => {
    setUpdateInvoiceDetails((prev) => updateInvoiceDetails + 1)
  }


  const deleteRenderMe = () => {
    setUpdateInvoiceDetails((prev) => updateInvoiceDetails + 1)
  }





    return (
        <Fragment>
            <Flex justifyContent={'space-evenly'} width={'80%'}>
            {(Object.keys(orderData).length > 0) && (Object.keys(tData).length > 0) && (orderItemDetails.length > 0)   ? 
            <>
            <Box p={5} w={'70%'} bgColor='#F5F5F5'>
                <DetailsHeader
                    title={"Tenure"}
                    colorScheme={'blue'}
                    variant={'outline'}
                    invoice={'Regenerate'} 
                    menuItems={["ID Generated","Tenure Activated","Initiated","Extended","Paused","In Progress","Fulfilled","Expired","Ended"]} 
                    changeStatusId={'test'}
                    orderName={id}
                    invoiceDetails={{tenure: tData, order: orderData, invoice: invoiceData}}
                    updateTenureDetailsTable={updateTenureDetailsTable}
                    tenureStatus={tData.statusId}
                    />

                <Details
                    title={"Tenure"}
                    order={'Order Placed'}
                    orderDetails={{title: orderItemDetails[0].title, variant: orderItemDetails[0].variant, img: orderItemDetails[0].productImg, quantity: orderItemDetails[0].quantity}}
                    tenureType={(tData?.tenurePeriodId?.charAt(0).toUpperCase() + tData?.tenurePeriodId?.slice(1).toLowerCase()) + (tData?.tenurePeriodId === "WEEKLY" ? "" : " Tenure") || null}
                    tenureTypeTotal={(tData?.tenurePeriodId === "WEEKLY") ? ('₹' + Number(tData?.TenureItem[0]?.pricePerWeek).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) + "/Week") 
                    : ('₹' + Number(tData?.TenureItem[0]?.pricePerMonth).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2, }) + "/Month") }
                    
                    rent={'₹' + Number((Number((tData?.tenurePeriodId === "MONTHLY" ? tData?.TenureItem[0]?.pricePerMonth : tData?.TenureItem[0]?.pricePerWeek))) * (tData?.tenurePeriodId === "MONTHLY" ? tData?.TenureItem[0]?.months : tData?.TenureItem[0]?.weeks)).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    btnColorScheme={tData.statusId === 'ACTIVE' ? 'green' : tData.statusId === 'CREATED'  ? 'pink' : 'red'}
                    btnText={tData.statusId}
                    orderDate={new Date(orderData?.placedDate).toLocaleDateString('en-IN')}
                    productName={"01/01/2023"}
                    productBtnText={"Extend Tenure"}
                    productBtnItems={tData?.tenurePeriodId === "MONTHLY" ? ["1 Month","2 Month","3 Month","4 Month","5 Month","6 Month","7 Month", "8 Month", "9 Month" , "10 Month",  "11 Month", "12 Month"] : ["1 Week", "2 Weeks", "3 Weeks", "4 Weeks", "5 Weeks", "6 Weeks", "7 Weeks", "8 Weeks"] }
                    row1={[{"Order ID": `${orderData.OrderName}`},{"Tenure ID": `#${id.split('-')[4]}`},{"Expiry Date": new Date(tData?.endDate).toLocaleDateString('en-IN')}]}
                    row2={[{"Tenure Type":(tData?.tenurePeriodId?.charAt(0).toUpperCase() + tData?.tenurePeriodId?.slice(1).toLowerCase())},
                    {[tData?.tenurePeriodId === "WEEKLY" ? "Start Date" : "Tenure Start Date"]: tData?.tenurePeriodId === "WEEKLY" ? new Date(tData?.startDate).toLocaleDateString('en-IN') : new Date((tData?.startDate)).toLocaleDateString('en-IN')},
                    {[tData?.tenurePeriodId === "WEEKLY" ? "End Date" : "Tenure End Date"]:new Date(tData?.endDate).toLocaleDateString('en-IN')},
                    {[tData?.tenurePeriodId === "WEEKLY" ? "Period" : "Tenure Period"]: `${tData?.tenurePeriodId === "MONTHLY" ? tData.TenureItem[0]?.months : tData.TenureItem[0]?.weeks} ${tData?.tenurePeriodId === "MONTHLY" ? tData.TenureItem[0]?.months === 1 ? "Month" : "Months" : tData.TenureItem[0]?.weeks === 1 ? "Week" : "Weeks"}`}]}
                    status={tData.statusId}
                    orderId={pid}
                    tenureId={id}
                    tenureData={tData}
                    partyId={orderData?.customerPartyId}
                    deleteRenderMe={deleteRenderMe}
                    orderTenure={orderTenure}
                    />
                {/* <AdditionalDetails
                    title={"Tenure"}
                    row1={[{"Order ID": "#789585"},{"Tenure ID": "#789585"},{"Billing Date":"01/01/2023"},{"Expiry Date": "01/01/2023"},{"Payment Status":"Initiated"},{"Payment Method":"----"}]}
                    row2={[{"Tenure Start Date":"01/01/2023"},{"Tenure End Date":"01/01/2023"},{"Tenure Type":"Monthly"},{"Tenure Periods":"6 Months"}]}
                    status={tData?.tenure_status}/> */}
                <TenureDetailsTable
                    head={["Invoice No.","Invoice Date","Amount","Amount (excl of gst)","Invoice Type","Payment Status", "Action"]}
                    data={invoiceData}
                    tenureType={tData?.tenurePeriodId} 
                    deleteRenderMe={deleteRenderMe}
                    tenureId={id}
                    />

                {/* <Timeline
                    text={"Only you and other admin members can see comments"} /> */}
            </Box>
            <Box pr={3} py={3}  w={'30%'} bgColor='#F5F5F5'>
            <RightSidebar
                    customerName={orderData.customerParty?.firstName + ' ' + orderData.customerParty?.lastName}
                    customerGmail={orderData.customerParty?.email}
                    customerPhone={orderData.customerParty?.phone}
                    shippingArea={orderData.shippingAddress}
                    shippingCity={orderData.shippingAddress?.city}
                    billingAddress={orderData.billingAddress}
                    title={'Tenure'} />
            </Box>
            </>
            :
            <Flex w={'80%'} justifyContent={'center'} mt={8}>
            <Spinner
            thickness='4px'
            speed='0.65s'
            emptyColor='gray.200'
            color='blue.500'
            size='xl'
            />
            </Flex>
} 
            </Flex>
        </Fragment>
    )
}

export default TenureDetails
